// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"355":"7f265b78","453":"0ecc119b"}[chunkId] + ".chunk.js";
};